import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { HeaderConfig } from '../../shared/utils/types';
import { AuthStore } from './auth-store';

@Injectable({
  providedIn: 'root'
})
export class Header {
  authService = inject(AuthStore);
  
  private configSubject = new BehaviorSubject<HeaderConfig>({
    title: null,
    showNotifications: true,
    showRightSection: true,
    dropdownOptions: [
      {
        label: 'HEADER.SETTINGS',
        iconPath: 'assets/icons/settings.svg',
        route: '/settings'
      },
      {
        label: 'HEADER.LOGOUT',
        iconPath: 'assets/icons/logout.svg',
        action: () => this.authService.logout()
      }
    ]
  });

  config$ = this.configSubject.asObservable();

  /** Update header config dynamically */
  updateConfig(config: Partial<HeaderConfig>) {
    const current = this.configSubject.value;
    this.configSubject.next({ ...current, ...config });
  }

  /** Reset to defaults */
  resetConfig() {
    this.configSubject.next({
      title: null,
      showNotifications: true,
      showRightSection: true,
      dropdownOptions: [
        {
          label: 'HEADER.SETTINGS',
          iconPath: 'assets/icons/settings.svg',
          route: '/settings'
        },
        {
          label: 'HEADER.LOGOUT',
          iconPath: 'assets/icons/logout.svg',
          action: () => this.authService.logout()
        }
      ],
    });
  }

  get currentConfig() {
    return this.configSubject.value;
  }
}
